import Card from "react-bootstrap/Card";
import './custom2.css';

export function RecommendationsAI({ recommendations }) {
    const data = "This is data from Child Component to the Parent Component."
    const ulStyle = { width: '100%', listStyleType: 'none',padding:'0px' }
    const liStyle = { color: 'black', fontSize: '16px', borderBottom: '1px solid #eee',padding:'10px',margin:"10px" }
  

    function recommPriority(skup){
      switch(skup){
        case 1:
          return "Crosssell";
        case 2:
           return "Upsell";
        default:
          return skup;
      }
    }

    function concatMaps(map, ...iterables) {
      for (const iterable of iterables) {
          for (const item of iterable) {
              map.set(...item);
          }
      }
  }
    
    return (
      
      <ul style={ulStyle}>
        {recommendations.map((v, index) => {
             console.log(v);
             return v.holderMap.REGULAR.map((r,i)=>{
                return <li  style={liStyle} className="card">
                          <div>Type:<span style={ { color: 'green' }}>Regular</span></div>
                          <table className="cattable">
                            <tr><th>SKU</th><th>Amount</th><th>Quantity</th><th>Relevance</th></tr>
            <tr><td>{r.skuCode}</td><td>{r.amount}</td><td>{r.quantity}</td><td>{r.relevanceType} ({r.relevance.toFixed(2)}%)</td></tr>
                          </table>
                      </li>
             }).concat(

             v.holderMap.UP_SELL.map((r,i)=>{
              return <li  style={liStyle} className="card">
                        <div>Type:<span style={ { color: 'indigo' }}>UP_SELL</span></div>
                        <table className="cattable">
                          <tr><th>SKU</th><th>Amount</th><th>Quantity</th><th>Relevance</th></tr>
          <tr><td>{r.skuCode}</td><td>{r.amount}</td><td>{r.quantity}</td><td>{r.relevanceType} ({r.relevance.toFixed(2)}%)</td></tr>
                        </table>
                    </li>
           })).concat(
           v.holderMap.CROSS_SELL.map((r,i)=>{
            return <li  style={liStyle} className="card">
                      <div>Type:<span style={ { color: 'orange' }}>CROSS_SELL</span></div>
                      <table className="cattable">
                        <tr><th>SKU</th><th>Amount</th><th>Quantity</th><th>Relevance</th></tr>
        <tr><td>{r.skuCode}</td><td>{r.amount}</td><td>{r.quantity}</td><td>{r.relevanceType} ({r.relevance.toFixed(2)}%)</td></tr>
                      </table>
                  </li>
         }));
        
        })}
        
      </ul>
      
    )
  }
  
  export function RecommendationSummaryAI({ recommendations,recordInfo }) {
    const data = "This is data from Child Component to the Parent Component."
    const ulStyle = { width: '100%', listStyleType: 'none' }
    const liStyle = { color: 'black', fontSize: '16px', borderBottom: '1px solid #eee' }
  
    // let changedr = new Array();
    // for(var k in recommendations){
    //     changedr.push({key:k,value:recommendations[k]})
    // }
    // recommendations=changedr;

    // const summary = recommendations.filter(s => s.value[5] > 1).reduce((acc, cur) => {
    //   return [acc[0] + cur.value[6], acc[1] + cur.value[7]]
    // }, [0, 0]);
  
    return (
      <>{ recommendations && recommendations.length>0 &&
        <Card style={{margin:"10px"}}>
          <Card.Body>
            <Card.Title style={{ color: "green" }}>Summary</Card.Title>
            <Card.Subtitle className="mb-2 text-muted">
            </Card.Subtitle>
            <Card.Text>
  
            </Card.Text>
            <ul style={ulStyle}>
              {/* <li>
                ClusterInfo : {JSON.stringify(recommendations)}
              </li> */}
              <li>
                Total Regular Items : {recommendations.reduce((sum,recommendation)=>sum+recommendation.holderMap.REGULAR.length,0)}
              </li>
              <li>
                Total Regular Amount : {recommendations.reduce((sum,recommendation)=>sum+recommendation.regularSum,0)}
              </li>
              <li>
                Total Upsell Amount : {recommendations.reduce((sum,recommendation)=>sum+recommendation.upsellSum,0)}
              </li>
              <li>
                Total Crossell Amount : {recommendations.reduce((sum,recommendation)=>sum+recommendation.crossSellSum,0)}
              </li>
              <li>
                Total Amount : {recommendations.reduce((sum,recommendation)=>sum+recommendation.total,0)}
              </li>
            </ul>
          </Card.Body>
        </Card>
  }
      </>
  
    )
  }
  